//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Rudkin',
  data() {
    return {}
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ER/Chart_Rudkin.vue